import { throttle } from 'lodash'
import { isSp, isIos } from '@/util/common'

export default {
  mounted () {
  },
  data() {
    return {
      targetScrollY: 0,
      targetScrollFlg: false,
      targetHeight: 0
    }
  },
  methods: {
    handleScroll: throttle(function (ev) {

      if (isSp()) {
        // 課02-123: SPはタイトルバーは隠さず、出っぱなしにする
        return
      }

      const { target: { scrollTop, scrollHeight, offsetHeight } } = ev
      const margin = 100


      // // iOSのみヘッダーが表示/非表示する動きに余裕をもたせる（バウンス効果対策）
      // if (isSp() && isIos()) {
      //   if (this.targetScrollY < scrollTop && scrollTop > margin) this.targetScrollFlg = true
      //   else if (this.targetScrollY > scrollTop && ev.target.scrollTop < scrollHeight - offsetHeight - margin) this.targetScrollFlg = false
      // } else {
      this.targetScrollY < scrollTop ? this.targetScrollFlg = true : this.targetScrollFlg = false
      // }


      this.targetScrollY = scrollTop
      this.targetHeight = offsetHeight
    }, 300)
  }
}
